import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsGlobalSettingsEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-configure-v2/src/assetsGlobalSettingsEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsConfigurationRoute } from '@jira/router-routes__assets-app-routes/src/assetsConfigurationRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const globalConfigurePageEntryPoint = createChromelessEntryPoint({
	main: assetsGlobalSettingsEntryPoint,
});

export const assetsConfigurationRouteEntry: Route = createEntry(assetsConfigurationRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	ufoName: 'servicedesk-cmdb-assets-configure',
	entryPoint: () => globalConfigurePageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-configure',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
	meta: {
		reporting: {
			id: APP_NAMES.INSIGHT_GLOBAL_CONFIGURATION,
			packageName: toPackageName(APP_NAMES.INSIGHT_GLOBAL_CONFIGURATION),
			teamName: 'astral',
		},
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
